import { UntypedFormGroup, ValidatorFn } from '@angular/forms'
import { Image } from 'app/models/questions/Image'
import { requireSelectionOnEachMatrixRow } from 'app/form-validators/RequireSelectionOnEachMatrixRowValidator'

export function requireMinImageSelection(image: Image): ValidatorFn {
  return function validate(formGroup: UntypedFormGroup) {
    if (!image.limitAnswersAmount) {
      requireSelectionOnEachMatrixRow(image)
    }

    const rowKeys = Object.keys(formGroup.controls)

    let imageCount = 0

    for (const idx in rowKeys) {
      const control = formGroup.controls[rowKeys[idx]]

      if (!control.enabled) {
        continue
      }

      const statementValues = control.get(image.formControlName).value

      for (const sKey in statementValues) {
        if (statementValues[sKey]) {
          imageCount++
        }
      }

    }

    if (imageCount < image.minAnswers.rows) {
      return {
        requireMinImageSelection: true
      }
    }

    return null
  }
}
